export function useMatrixFlattener<T>(): (arr: any[][]) => T[] {
  const flatten: (arr: any[][]) => T[] = (arr) => {
    return arr?.reduce(function (flat, toFlatten) {
      return flat?.concat(
        Array.isArray(toFlatten) ? flatten(toFlatten) : toFlatten
      );
    }, []);
  };
  return flatten;
}
